export const SUMMARY_RENAME_DIALOG_TEST_IDS = {
  cancelButton: 'summary-rename-dialog-cancel',
  closeButton: 'summary-rename-dialog-close',
  dialog: 'summary-rename-dialog',
  nameInput: 'summary-rename-dialog-name',
  saveButton: 'summary-rename-dialog-save',
} as const;
